import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppGlobals } from '@app/app.global';

@Injectable({
  providedIn: 'root'
})
export class CompareInvoiceService {

  constructor(private http: HttpClient, private appGlobals: AppGlobals) { }

  getInvoiceComparisions(queryParams) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.metadata}compare-invoice`, { params: queryParams })
  }

  getCompanyList(isPushToPetpoojaList = false, search = '') {
    let params = new HttpParams()
      .set('isPushToPetpoojaList', isPushToPetpoojaList.toString());

    if (search) {
      params = params.set('search', search);
    }

    return this.http.get<any>(
      `${this.appGlobals.apiUrl.metadata}company/list`,
      { params }
    );
  }
}
